// admin.audit-log.tsx — T094 (5/5)
// Route : /admin/audit-log

import { createFileRoute } from "@tanstack/react-router";

import { AuditLogPage } from "@/presentation/pages/AuditLogPage";

export const Route = createFileRoute("/admin/audit-log")({
  component: AuditLogPage,
});
